/**
 * Base URL da API REST (termina em /api quando usa hostname dinâmico).
 * REACT_APP_API_URL tem prioridade (build/deploy explícitos).
 */
export function getApiBaseUrl() {
  const env = process.env.REACT_APP_API_URL;
  if (env && String(env).trim()) {
    return String(env).trim();
  }
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const port = process.env.REACT_APP_API_PORT || '3001';
    return `http://${window.location.hostname}:${port}/api`;
  }
  return 'http://localhost:3001/api';
}
